module.exports = __webpack_public_path__ + "img/macaw.a98ceeee.png";